// extracted by mini-css-extract-plugin
export var bannerCard = "banner-card-module--banner-card--smRRH";
export var button = "banner-card-module--button--PwqLE";
export var buttonSection = "banner-card-module--button-section--p7vD0";
export var content = "banner-card-module--content--yjZ7U";
export var hidden = "banner-card-module--hidden--taNSQ";
export var title = "banner-card-module--title--zA--1";
export var visible = "banner-card-module--visible--zR46v";